export default {
  hour: 'Hour',
  minutes: 'Minutes',
  kilometer: 'Kilometer',
  meter: 'Meter',
  tons: 'Tons',
  kilogerams: 'Kilograms',
  grams: 'Grams'
}
